/**
 * @generated SignedSource<<f78ed3af47f5375caaa781fbbc6cff46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WelcomeScreenHasPipelinesQuery$variables = Record<PropertyKey, never>;
export type WelcomeScreenHasPipelinesQuery$data = {
  readonly pipelinesRest: {
    readonly " $fragmentSpreads": FragmentRefs<"WelcomeScreenFragment">;
  } | null | undefined;
};
export type WelcomeScreenHasPipelinesQuery = {
  response: WelcomeScreenHasPipelinesQuery$data;
  variables: WelcomeScreenHasPipelinesQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WelcomeScreenHasPipelinesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pipelines",
        "kind": "LinkedField",
        "name": "pipelinesRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WelcomeScreenFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WelcomeScreenHasPipelinesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pipelines",
        "kind": "LinkedField",
        "name": "pipelinesRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "790be4ed9fb4cc51ed54f921644dd72f",
    "id": null,
    "metadata": {},
    "name": "WelcomeScreenHasPipelinesQuery",
    "operationKind": "query",
    "text": "query WelcomeScreenHasPipelinesQuery {\n  pipelinesRest {\n    ...WelcomeScreenFragment\n  }\n}\n\nfragment WelcomeScreenFragment on Pipelines {\n  count\n}\n"
  }
};

(node as any).hash = "dbf43286aa50b8e0e3d122ac05319be2";

export default node;
